import { InputData } from '@sharedModule/models/input-data.model';

/** Field metadata for the conditional transfer-detail inputs. */
export const TRANSFER_DETAILS_ATTRIBUTES: Record<string, InputData> = {
  transferType: {
    type: 'select',
    key: 'transfer_type_po',
    label: 'Transfer Type',
  },
  // bank-transfer
  bank: { type: 'select', key: 'bank', label: 'Bank' },
  bankBranch: { type: 'select', key: 'bank_branch_id', label: 'Branch' },
  bankAccountNumber: {
    type: 'text',
    key: 'bank_account_number',
    label: 'Account Number',
  },
  bankAccountName: {
    type: 'text',
    key: 'bank_account_name',
    label: 'Account Holder Name',
  },
  bankAccountType: {
    type: 'select',
    key: 'bank_account_type',
    label: 'Account Type',
  },
  bankIfscCode: {
    type: 'text',
    key: 'bank_ifsc_code',
    label: 'IFSC / Sort Code',
  },
  bankAdditionalDetails: {
    type: 'text',
    key: 'bank_additional_details',
    label: 'Additional Details',
  },
  // cash-pickup
  collectionState: {
    type: 'select',
    key: 'collection_point_state',
    label: 'State',
  },
  collectionCity: {
    type: 'select',
    key: 'collection_point_city',
    label: 'City',
  },
  collectionPoint: {
    type: 'select',
    key: 'collection_point_id',
    label: 'Collection Point',
  },
  // mobile-transfer
  mobileNetwork: {
    type: 'select',
    key: 'mobile_transfer_network_id',
    label: 'Mobile Network',
  },
  mobileNumber: {
    type: 'tel',
    key: 'mobile_transfer_number',
    label: 'Mobile Number',
  },
};
